module.exports = __webpack_public_path__ + "static_1706175070126/img/billboard_new.1e908a09.png";